import axios from 'axios';

const CAO_ENDPOINT = 'secure/cla-usages';
const DELETE_CAO_ENDPOINT = 'secure/cla-usages/:claId';

export type CAOType =
  | 'APHOTHEKEN'
  | 'GEESTELIJKE_GEZONDHEIDSZORG'
  | 'GEHANDICAPTENZORG'
  | 'HUISARTSENZORG'
  | 'JEUGDZORG'
  | 'KINDEROPVANG'
  | 'VERZORGING_VERPLEGING_THUISZORG'
  | 'SOCIAAL_WERK'
  | 'ZIEKENHUIZEN'
  | 'OVERIG';

export type CAO = {
  type: string;
  id: number;
};

export const getCAO = () => axios.get<CAO[]>(CAO_ENDPOINT);

type CAOPayload = {
  type: CAOType;
};

export const saveCAO = (payload: CAOPayload) =>
  axios.post<CAOPayload>(CAO_ENDPOINT, payload);

export const deleteCAO = (claId: number) =>
  axios.delete(DELETE_CAO_ENDPOINT, {
    pathParams: {
      claId
    }
  });
